import {Card} from '../dto/card';
import {BankTransferLoad} from '../dto/bankTransferLoad';

export class PartnerWalletLoadModel {
  public id: number;
  public amount: number;
  public loadFee: number;
  public amountToLoad: number;
  public isExported: boolean;
  public description: string;
  public createDate: Date;
  public status: number;
  public exportedDate: Date;
  public confirmationDate: Date;
  public cardId: number;
  public card: Card;
  public cardToken: string;

  public bankTransferLoad: BankTransferLoad;
  public bankTransferLoadId: number | null;
  public documents: PartnerWalletLoadDocument[];

}

export class PartnerWalletLoadDocument {
  public id: number;
  public name: string;
  public fileId: number;
}

